module.exports = __webpack_public_path__ + "img/cancel.f961869d.svg";